import React from 'react';
import { stage as stageEnum } from '../../../../utils';
import { ILine as Line, IStage as Stage } from '../../../../global';
import MobileStage from './Stage';
import AddStage from './AddStage';
import MobileStockOnHand from './MobileStockOnHand';

interface Props {
  line: Line;
  handleAddStage?: (stageName: string) => void;
  handleStageUpdate?: (...args) => void;
  addOrDeleteError?: (...args) => void;
}
export default function MobileStages({
  line,
  handleAddStage = () => {},
  handleStageUpdate = () => {},
  addOrDeleteError = () => {},
}: Props) {
  const { stages, edit } = line;

  return (
    <>
      {stages
        .filter((stage: Stage) => !stage.deleted)
        .map((stage: Stage) => (
          <div key={stage.id}>
            {stage.name === stageEnum.sellingStart.value ? (
              <MobileStockOnHand
                {...{ line, stage, handleStageUpdate, addOrDeleteError }}
              />
            ) : (
              <MobileStage
                {...{ stage, handleStageUpdate, addOrDeleteError }}
              />
            )}
          </div>
        ))}
      {edit && <AddStage handleAddStage={handleAddStage} />}
    </>
  );
}
